import { Component, OnInit } from '@angular/core';
import { ShuttleComponent } from '../shuttle/shuttle.component';
import {CookieService} from 'angular2-cookie/core';
import {Router} from "@angular/router";
import { shuttleService } from '../data/shuttle.service';
import {Location} from '@angular/common';

@Component({
  selector: 'app-shuttle-at-stop',
  templateUrl: './shuttle-at-stop.component.html',
  styleUrls: ['./shuttle-at-stop.component.css'],

})

export class ShuttleAtStopComponent extends ShuttleComponent  implements OnInit {

     constructor(private c_cookieService:CookieService,private c_router: Router, private c_shuttleService:shuttleService,private c_location:Location) {
          super(c_cookieService,c_router,c_shuttleService,c_location);
          console.log('shuttle en route constructor');
          //this.init();

     }
     ngOnInit() {
          super.ngOnInit();
          var audio = new Audio('http://shuttles.thedesigngrouponline.com/assets/ding.mp3');
          //console.log(this.timer);

          setInterval(()=>{
               //console.log(this.timer);
               /*if(this.timer == '01:00'){
                    audio.play()
               }
               if(this.timer == '02:00'){
                    audio.play()
               }*/
               if(this.timer == '03:00'){
                    audio.play()
               }
               if(this.timer == '00:30'){
                    //audio.play()
               }

          },1000)


     }
     ngOnDestroy(): void {
          console.log(this.timer);

          console.log('destroy');
          console.log(this.timer);
         this.timer = '';
         console.log(this.timer);
      }

}
